import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }: any) => theme.body};
    color: ${({ theme }: any) => theme.text};
  }
  a, button {
    color: ${({ theme }: any) => theme.text};
  }
  p {
    color: ${({ theme }: any) => theme.blurText};
  }
  header {
    background: ${({ theme }: any) => theme.body};
  }
  .header-border, .sider {
    border-color: ${({ theme }: any) => theme.border}
  }
  .menu-collapse {
    background: ${({ theme }: any) => theme.body};
  }
  .menu-collapse-links {
    border-color: ${({ theme }: any) => theme.border}
  }
  .toggle-mode {
    background: ${({ theme }: any) => theme.gradient};
  }
  .trans-bg {
    background: ${({ theme }: any) => theme.body};
  }
  input {
    border-color: ${({ theme }: any) => theme.body}
  }
  .stack-item {
    background: ${({ theme }: any) => theme.risedBg};
  }
  .input-container__label {
    background-color:  ${({ theme }: any) => theme.body};
  }
  .constrast-section, .sider {
    background:  ${({ theme }: any) => theme.constrast};
  }
  .timeline-item__line,.timeline-line::after {
    background-color: ${({ theme }: any) => theme.text};
  }
  .timeline-line::before {
    background-color: ${({ theme }: any) => theme.body};
  }
  .flip-card {
    background-color: ${({ theme }: any) => theme.risedBg};
  }
  .projects-card__item {
    background:  ${({ theme }: any) => theme.body};
  }
  .footer-content__title {
    border-bottom-color: ${({ theme }: any) => theme.text} 
  }
  .toggle-icon {
    border-color: ${({ theme }: any) => theme.text} 
  }
  .spinner {
    border-top-color: ${({ theme }: any) => theme.primary};
  }
`

export const lightTheme = {
  body: '#ffffff',
  text: '#212227',
  primary: '#6246ea',
  blurText: '#4b5365',
  constrast: '#e7edf1',
  border: 'rgba(229,231,235,1)',
  blurBg: 'hsla(0,0%,100%,0.85)',
  risedBg: '#fafafa',
  gradient: 'linear-gradient(#8672e7, #fffeff)',
}

export const darkTheme = {
  body: '#0c1017',
  text: '#fff',
  primary: '#fff',
  blurText: '#9fa5b3',
  constrast: '#111725',
  border: 'rgba(31, 41, 55, 1)',
  blurBg: 'rgba(14,20,27,0.85)',
  risedBg: 'rgba(14,20,27,0.85)',
  gradient: 'linear-gradient(#091236, #5d35eb)',
}
